import React from "react";
import styled from "styled-components";
import ActionBtnU from "../ActionBtnU";

// TypeScript types for props
interface AlertDialogProps {
  message: any;
  onConfirm?: () => void;
  onCancel?: () => void;
  loading?: any;
  actionButtonText?: string;
  btnPos?: string;
  disableActionButton?: boolean;
}

// Styled components
const DialogContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 19888;
`;

const DialogContent = styled.div`
  background-color: white;
  padding: 40px;
  box-sizing: content-box;
  border-radius: 8px;
  max-height: 80%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  /* Mobile Styles */
  @media only screen and (max-width: 400px) {
    width: 90%;
  }

  @media only screen and (min-width: 961px) {
    width: 35%;
  }
  @media only screen and (min-width: 400px) and (max-width: 428px) {
    width: 70%;
  }
  @media only screen and (min-width: 429px) and (max-width: 960px) {
    width: 50%;
  }
`;
interface IBtnProps {
  btnPos?: string;
}
const ButtonsContainer = styled.div<IBtnProps>`
  display: flex;
  justify-content: ${(props) => props.btnPos ?? "flex-end"};
  margin-top: 20px;
  width: 100%;
`;
const MessageContentContainer = styled.div`
  width: 100%;
`;
const MessageContent = styled.div`
  text-align: center;
`;

const AlertDialog: React.FC<AlertDialogProps> = ({
  message,
  onConfirm,
  onCancel,
  loading = false,
  actionButtonText,
  btnPos,
  disableActionButton = false,
}) => {
  return (
    <DialogContainer>
      <DialogContent>
        <MessageContentContainer>
          <MessageContent>{message}</MessageContent>
        </MessageContentContainer>
        {(onCancel || onConfirm) && (
          <ButtonsContainer btnPos={btnPos}>
            {onCancel && (
              <ActionBtnU
                largeWidth="30%"
                onClick={onCancel}
                purple_border
                className="mr-4"
                disabled={loading}
              >
                Cancel
              </ActionBtnU>
            )}
            {onConfirm && (
              <ActionBtnU
                largeWidth="30%"
                onClick={onConfirm}
                purpleBg
                white_color
                disabled={loading || disableActionButton}
              >
                {actionButtonText ?? "Continue"}
              </ActionBtnU>
            )}
          </ButtonsContainer>
        )}
      </DialogContent>
    </DialogContainer>
  );
};

export default AlertDialog;
